import styled from '@emotion/styled';
import { device } from '@landsbankinn/ui';
import React from 'react';

const Host = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-bottom: -20px;

  > * {
    margin-bottom: 20px;

    &:nth-child(3) {
      order: 4;
    }

    &:nth-child(4) {
      order: 3;
    }
  }
  @media ${device.ipadPro} {
    display: flex;
    flex-flow: row wrap;

    > * {
      width: calc(50% - 20px);
      margin: 0 10px 20px;

      &:nth-child(3) {
        order: initial;
      }

      &:nth-child(4) {
        order: initial;
      }
    }
  }
`;

export const BoxGroup: React.FC = ({ children }) => {
  return <Host>{children}</Host>;
};
